import React from "react";

const Pro = ({ className = "", size }) => {
  const sizeClass = size === "large" ? "scale-110" : "";
  return (
    <span className={`label-group ${sizeClass} ${className}`.trim()}>
      Pro
    </span>
  );
};

export default Pro;
